export default function isToggleEnable (toggle) {
  if (!toggle) return false
  return toggle.toLowerCase() === 'on'
}
